import type { Metadata } from "../api/client";

export function formatMetadataForFilters(metadata: Metadata | null | undefined): {
  services: string[];
  instances: string[];
} {
  if (!metadata) return { services: [], instances: [] };
  return {
    services: metadata.services.map((s) => s.service_name),
    instances: metadata.services.flatMap((s) => s.instances.map((i) => i.instance_id)),
  };
}
